import { useSelector } from 'react-redux';

import { getHeatingTypeV2 } from 'shared/components/bti_house_data/helpers';
import { EHeatingType } from 'shared/repositories/offer-card/entities/building/BuildingSchema';
import { getOfferFeature } from 'shared/utils/getOfferFeature';

import { IOfferSummaryInfoItemProps } from '../../../../../components/OfferSummaryInfo';
import { offerSelector } from '../../../../../selectors';
import {
  getDrainageType,
  getGasType,
  getSuburbanWaterType,
  getWcLocationType,
} from '../../../../../utils/land_helpers';
import { getOfferType, isSuburban } from '../../../../../utils/offer_type';

export const useSummaryInfoCommunicationProps = (): IOfferSummaryInfoItemProps[] | null => {
  const offer = useSelector(offerSelector);

  const offerType = getOfferType(offer);

  const isSuburbanOffer = isSuburban(offerType);

  if (!isSuburbanOffer) {
    return null;
  }

  const summaryInfoItems: IOfferSummaryInfoItemProps[] = [];

  const wcLocation = getWcLocationType(offer);
  if (wcLocation) {
    const wcValue = offer.wcsCount ? `${offer.wcsCount} ${wcLocation.toLowerCase()}` : wcLocation;
    summaryInfoItems.push({ name: 'Санузел', value: wcValue });
  }

  const drainage = getOfferFeature('Канализация', getDrainageType(offer), offer.hasDrainage);
  if (drainage) {
    summaryInfoItems.push(drainage);
  }

  const water = getOfferFeature('Водоснабжение', getSuburbanWaterType(offer), offer.hasWater);
  if (water) {
    summaryInfoItems.push(water);
  }

  if (offer.building?.heatingType) {
    summaryInfoItems.push({
      name: 'Отопление',
      value: getHeatingTypeV2(offer.building.heatingType as EHeatingType) ?? 'Нет информации',
    });
  }

  summaryInfoItems.push({
    name: 'Электричество',
    value: offer.hasElectricity ? 'Есть' : 'Нет',
  });

  const gas = getOfferFeature('Газ', getGasType(offer), offer.hasGas);
  if (gas) {
    summaryInfoItems.push(gas);
  }

  return summaryInfoItems;
};
